"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var precisions = [1, 10, 1e2, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8];
/**
 * zaokrągla liczbę zmiennoprzecinkową uwzględniając przekłamania JS
 * @param value liczba
 * @param precision do ilu miejsc po przecinku zaokrąglić, domyślnie 2
 */
function mround(value, precision) {
    if (precision === void 0) { precision = 2; }
    if (value === undefined) {
        return value;
    }
    // return Number(Math.round(+(`${value}e${precision}`)) + `e-${precision}`);
    // const nnumber = value * precisions[precision];
    // if (nnumber % 1 === 0) {
    if (value % 1 === 0) {
        return value;
    }
    else {
        // return Math.round(nnumber + 0.0000000000001) / precisions[precision];
        return Math.round(value * precisions[precision] + 0.0000000000001) / precisions[precision];
    }
}
exports.default = mround;
//# sourceMappingURL=mround.js.map